import type { Types as IdunSoftTypes } from '../types';
import type { OutTypes } from './schedules';

export default (locations: IdunSoftTypes.location[]): OutTypes.location[] => {
  return locations
    .reduce<OutTypes.location[]>((acc, location, index) => {
      const ids = location['ID'];
      if (!ids)
        throw new Error('A location does not have a unique key');

      if (acc.some(x => x.ids == ids))
        throw new Error(`A location ID "${ids}" exists multiple times at indices ${ index } and ${ acc.findIndex(x => x.ids == ids) }`);

      return acc.concat({
        ids:         ids,
        displayName: location['Namn']
      });
    }, []);
};